import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  ListPendingOrdersPage,
  ListRejectedOrdersPage,
  ListOrdersPage,
  CreateOrderPage,
  OrdersCalendarPage,
  OrderPrintingPage,
} from 'pages/Scheduling';

const schedulingRoutes = ({
  isLoggedIn,
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'agendamento',
  element: isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: 'calendario',
      element: <OrdersCalendarPage />,
    },
    {
      path: 'solicitacoes/:orderType',
      element: <ListOrdersPage />,
    },
    {
      path: 'solicitacoes-pendentes',
      element: <ListPendingOrdersPage />,
    },
    {
      path: 'criar-solicitacao-estoque',
      element: <CreateOrderPage />,
    },
    {
      path: ':id/impressao',
      element: <OrderPrintingPage />,
    },
    {
      path: 'solicitacoes-reprovadas',
      element: <ListRejectedOrdersPage />,
    },
  ],
});

export default schedulingRoutes;
